import { render, staticRenderFns } from "./RegisterSharedClientInformation.vue?vue&type=template&id=0f5be9c0"
import script from "./RegisterSharedClientInformation.vue?vue&type=script&lang=js"
export * from "./RegisterSharedClientInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports